import {
  useQuery,
  useMutation,
  useQueryClient,
  type QueryClient,
  type UseQueryResult,
  type UseMutationResult,
} from '@/lib/query';
import {
  fetchRoutingUserDetails,
  redeemAccessKey,
  type RoutingUserDetails,
} from '@/lib/api/routingApi';

const ROUTING_USER_DETAILS_QUERY_KEY: readonly string[] = ['routing-user-details'];

/** Lädt die Routing-User-Details (inkl. Subscription-Status). */
export const useRoutingUserDetails = (): UseQueryResult<RoutingUserDetails | null> => {
  return useQuery<RoutingUserDetails | null>({
    queryKey: ROUTING_USER_DETAILS_QUERY_KEY,
    queryFn: fetchRoutingUserDetails,
    retry: (failureCount): boolean => failureCount < 5,
    retryDelay: 2000,
    staleTime: 60_000,
  });
};

/** Löst einen Access-Key ein und invalidiert anschließend die User-Details. */
export const useRedeemAccessKey = (): UseMutationResult<RoutingUserDetails, Error, string> => {
  const queryClient: QueryClient = useQueryClient();

  return useMutation<RoutingUserDetails, Error, string>({
    mutationFn: (code): Promise<RoutingUserDetails> => redeemAccessKey(code),
    onSuccess: (): void => {
      void queryClient.invalidateQueries({ queryKey: ROUTING_USER_DETAILS_QUERY_KEY });
    },
  });
};
